var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.837,
    height: 40.837,
    viewBox: "0 0 40.837 40.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-button",
    transform: "translate(-1459 4343)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 19,
    cy: 19.5,
    rx: 19,
    ry: 19.5,
    transform: "translate(1460 -4342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Close_button",
    "data-name": "Close button",
    transform: "translate(850.832 -4723.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M23.793,3.375A20.419,20.419,0,1,0,44.212,23.794,20.415,20.415,0,0,0,23.793,3.375Zm5.173,27.81-5.173-5.173L18.62,31.185A1.569,1.569,0,1,1,16.4,28.967l5.173-5.173L16.4,18.62A1.569,1.569,0,0,1,18.62,16.4l5.173,5.173L28.967,16.4a1.569,1.569,0,0,1,2.219,2.219l-5.173,5.173,5.173,5.173a1.576,1.576,0,0,1,0,2.219A1.558,1.558,0,0,1,28.967,31.185Z",
    transform: "translate(604.793 377.474)",
    fill: "#5046e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.498200c9542b39cd4c5c7166a06060d5.svg";
export { ForwardRef as ReactComponent };